import { formatCSV } from './format-csv.js';
import { CSS_DOWNLOAD_FILENAME } from '../../../charts/core/constants.js';
import { downloadCSV } from '../../../core/utils/download.js';
import type { TreeMapRootNode } from '../types/treemap.js';

const getRootNode = (name: string | undefined, value: number) => {
  const rootName = name ? `${name} - (Root)` : 'Root';
  return { name: rootName, value, parent: '-' };
};

const getNodeList = (tree: TreeMapRootNode) => {
  const rootNode = getRootNode(tree?.name, tree.value);
  const nodes = [rootNode];

  tree.nodes?.forEach((cluster) => {
    nodes.push({ name: cluster.name, value: cluster.value, parent: 'Root' });
    cluster.nodes?.forEach((leaf) => {
      nodes.push({ name: leaf.name, value: leaf.value, parent: cluster.name });
    });
  });
  return nodes;
};

export const buildAndDownloadCsv = (tree: TreeMapRootNode) => {
  const nodeList = getNodeList(tree);
  const csvString = formatCSV(nodeList);
  downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
};
